/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateToolsetRequestBody,
  UpdateToolsetRequestBody$Outbound,
  UpdateToolsetRequestBody$outboundSchema,
} from "../components/updatetoolsetrequestbody.js";

export type UpdateToolsetSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpdateToolsetSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateToolsetSecurity = {
  option1?: UpdateToolsetSecurityOption1 | undefined;
  option2?: UpdateToolsetSecurityOption2 | undefined;
};

export type UpdateToolsetRequest = {
  /**
   * The slug of the toolset to update
   */
  slug: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateToolsetRequestBody: UpdateToolsetRequestBody;
};

/** @internal */
export type UpdateToolsetSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateToolsetSecurityOption1$outboundSchema: z.ZodMiniType<
  UpdateToolsetSecurityOption1$Outbound,
  UpdateToolsetSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateToolsetSecurityOption1ToJSON(
  updateToolsetSecurityOption1: UpdateToolsetSecurityOption1,
): string {
  return JSON.stringify(
    UpdateToolsetSecurityOption1$outboundSchema.parse(
      updateToolsetSecurityOption1,
    ),
  );
}

/** @internal */
export type UpdateToolsetSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateToolsetSecurityOption2$outboundSchema: z.ZodMiniType<
  UpdateToolsetSecurityOption2$Outbound,
  UpdateToolsetSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function updateToolsetSecurityOption2ToJSON(
  updateToolsetSecurityOption2: UpdateToolsetSecurityOption2,
): string {
  return JSON.stringify(
    UpdateToolsetSecurityOption2$outboundSchema.parse(
      updateToolsetSecurityOption2,
    ),
  );
}

/** @internal */
export type UpdateToolsetSecurity$Outbound = {
  Option1?: UpdateToolsetSecurityOption1$Outbound | undefined;
  Option2?: UpdateToolsetSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateToolsetSecurity$outboundSchema: z.ZodMiniType<
  UpdateToolsetSecurity$Outbound,
  UpdateToolsetSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateToolsetSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateToolsetSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateToolsetSecurityToJSON(
  updateToolsetSecurity: UpdateToolsetSecurity,
): string {
  return JSON.stringify(
    UpdateToolsetSecurity$outboundSchema.parse(updateToolsetSecurity),
  );
}

/** @internal */
export type UpdateToolsetRequest$Outbound = {
  slug: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateToolsetRequestBody: UpdateToolsetRequestBody$Outbound;
};

/** @internal */
export const UpdateToolsetRequest$outboundSchema: z.ZodMiniType<
  UpdateToolsetRequest$Outbound,
  UpdateToolsetRequest
> = z.pipe(
  z.object({
    slug: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateToolsetRequestBody: UpdateToolsetRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      updateToolsetRequestBody: "UpdateToolsetRequestBody",
    });
  }),
);

export function updateToolsetRequestToJSON(
  updateToolsetRequest: UpdateToolsetRequest,
): string {
  return JSON.stringify(
    UpdateToolsetRequest$outboundSchema.parse(updateToolsetRequest),
  );
}
